/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Very_HighInputs */

const en_very_high = /** @type {(inputs: Very_HighInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Very High`)
};

const th_very_high = /** @type {(inputs: Very_HighInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`สูงมาก`)
};

const ja_very_high = /** @type {(inputs: Very_HighInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`非常に高い`)
};

const fr_very_high = /** @type {(inputs: Very_HighInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Très élevé`)
};

const es_very_high = /** @type {(inputs: Very_HighInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Muy alto`)
};

const ru_very_high = /** @type {(inputs: Very_HighInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Очень высокий`)
};

const zh_very_high = /** @type {(inputs: Very_HighInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`非常高`)
};

const vi_very_high = /** @type {(inputs: Very_HighInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rất cao`)
};

/**
* | output |
* | --- |
* | "Very High" |
*
* @param {Very_HighInputs} inputs
* @param {{ locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }} options
* @returns {LocalizedString}
*/
export const very_high = /** @type {((inputs?: Very_HighInputs, options?: { locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Very_HighInputs, { locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_very_high(inputs)
	if (locale === "ja") return ja_very_high(inputs)
	if (locale === "fr") return fr_very_high(inputs)
	if (locale === "es") return es_very_high(inputs)
	if (locale === "ru") return ru_very_high(inputs)
	if (locale === "zh") return zh_very_high(inputs)
	if (locale === "vi") return vi_very_high(inputs)
	return en_very_high(inputs)
});